import React, { ReactNode } from 'react';
import {
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps,
} from '@material-ui/core';

interface SelectLabelledProps extends FormControlProps {
  label?: string;
  helperText?: string;
  value: string | number;
  name: string;
  SelectProps?: SelectProps;
  children: ReactNode | ReactNode[];
  required?: boolean;
}

export const SelectLabelled = ({
  helperText,
  label,
  value,
  name,
  SelectProps,
  children,
  ...props
}: SelectLabelledProps) => (
  <FormControl variant="outlined" {...props}>
    {label && <InputLabel id={`${name}-label`}>{label}</InputLabel>}
    <Select
      labelId={`${name}-label`}
      value={value}
      label={label}
      {...SelectProps}
    >
      {children}
    </Select>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);
